import { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Search.css";
import { WeeklyContextMenu } from './WeeklyContextMenu';
import { useData } from '../contexts/DataContext';

function Search() {
  const [search, setInput] = useState("");
  const navigate  = useNavigate();
  const location  = useLocation();
  const { weeklyMeals } = useData();

  const [contextMenu, setContextMenu] = useState(null);

  // Clear input when leaving search page
  useEffect(() => {
    if (!location.pathname.includes("/searched")) {
      setInput("");
    }
  }, [location.pathname]);

  const submitHandler = (e) => {
    e.preventDefault();
    navigate(`/searched/${search}`);
  };

  const handleContextMenu = (e, recipe) => {
    e.preventDefault();
    setContextMenu({ x: e.clientX, y: e.clientY, recipe });
  };

  // Expose to child pages (same as before)
  useEffect(() => {
    window.searchPageContextMenu = handleContextMenu;
    return () => { delete window.searchPageContextMenu; };
  }, []);

  useEffect(() => {
    const handleClickOutside = () => setContextMenu(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      {contextMenu && (
        <WeeklyContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          recipe={contextMenu.recipe}
          weeklyMeals={weeklyMeals}
          onClose={() => setContextMenu(null)}
        />
      )}

      <form className="search-form" onSubmit={submitHandler}>
        <div>
          <FaSearch />
          <input
            type="text"
            placeholder="Search... e.g. chicken, low carb, snack..."
            value={search}
            onChange={(e) => setInput(e.target.value)}
          />
        </div>
      </form>
    </>
  );
}

export default Search;
